module.exports = __webpack_public_path__ + "static/media/start_gas_bg.163eb387.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start_gas_bg.svg
// module id = 116
// module chunks = 0